import { useAuth0 } from "@auth0/auth0-react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const location = useLocation();

  if (!isAuthenticated) {
    // Store the current location in localStorage to redirect back here after login
    window.localStorage.setItem("redirectTo", location.pathname);
    loginWithRedirect();
    return <div>Loading...</div>; // Or a spinner, etc.
  }

  return children;
};

export default ProtectedRoute;
